import styled from '@emotion/styled';
import SelectAsync from 'react-select/async';

import { bootstrapStyles } from './styles';
import { createStyledSelect } from './helpers';

export default styled(createStyledSelect(SelectAsync, bootstrapStyles))``;
